import { HasProduct, HasProductContext, withProduct, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { productCarouselProductStyles as productStyle } from "@tKgpco/Overrides/Components/ProductCarouselProduct";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

// eslint-disable-next-line no-use-before-define
type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps> & HasProductContext;

const mapStateToProps = (state: ApplicationState, ownProps: HasProduct) => ({
    configurationSelection: state.pages.productDetails.configurationSelection,
    configurationCompleted: state.pages.productDetails.configurationCompleted,
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
    unitPrice: ownProps.productInfo && ownProps.productInfo.pricing && ownProps.productInfo.pricing.unitNetPrice,
    subscription: state.pages.productDetails.subscription,
});

export interface ProductDetailsAddToCartButtonStyles {
    button?: ButtonPresentationProps;
}

export const addToCartButtonStyles: ProductDetailsAddToCartButtonStyles = {
    button: {
        css: css`
            width: 100%;
            border-radius: 0px 10px 10px 0px;
            background: transparent linear-gradient(180deg, #44a8f7 0%, #1e75ba 100%) 0% 0% no-repeat;
            border: none;
            text-transform: uppercase;
            font-size: ${TYPOGRAPHY.size.smaller};
            background-color: #1e75ba;
            color: ${COLORS.white};
            &:focus {
                outline: none;
            }
            &:hover {
                background-color: ${COLORS.link.base};
            }
            @media (max-width: 991px) {
                border-radius: 10px;
            }
            span {
                font-size: ${TYPOGRAPHY.size.smaller};
                font-weight: ${TYPOGRAPHY.weight.bold};
            }
        `,
    },
};

const styles = addToCartButtonStyles;

const ProductDetailsAddToCartButton = ({
    configurationSelection,
    configurationCompleted,
    variantSelectionCompleted,
    subscription,
    unitPrice,
    productContext
}: Props) => {
    const { productInfo } = productContext;
    let showPriceMessage = true;
    if(productInfo?.pricing?.additionalResults?.showPriceMessage === "false") {
        showPriceMessage = false;
    }
    if(!showPriceMessage) {
        return null;
    }
    return (
        <ProductAddToCartButton
            configurationSelection={configurationSelection}
            configurationCompleted={configurationCompleted}
            variantSelectionCompleted={variantSelectionCompleted}
	        subscription={subscription}
            extendedStyles={styles.button}
            // extendedStyles={productStyle.productAddToCartButtonStyles}
            data-test-selector="addProductToCart"
        />
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(withProductContext(ProductDetailsAddToCartButton))),
    definition: {
        displayName: "Add to Cart Button",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
